import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Capture the PWA install prompt as EARLY as possible (Chrome fires beforeinstallprompt before
// React mounts, so a component-level listener misses it). Stored globally + broadcast via events
// so the persistent Install button can use it at any time.
if (typeof window !== "undefined") {
  window.__esvanInstallPrompt = window.__esvanInstallPrompt || null;
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    window.__esvanInstallPrompt = e;
    window.dispatchEvent(new Event("esvan-installable"));
  });
  window.addEventListener("appinstalled", () => {
    window.__esvanInstallPrompt = null;
    window.dispatchEvent(new Event("esvan-installed"));
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false, retry: 1 },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register the PWA service worker + seamless auto-update of open tabs
if ("serviceWorker" in navigator) {
  const hadController = !!navigator.serviceWorker.controller;
  let refreshing = false;
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").then((reg) => {
      reg.update().catch(() => {});
      // A new worker is waiting/installed → activate it immediately so tabs get fresh assets.
      const promote = (sw) => sw && sw.state === "installed" && navigator.serviceWorker.controller && sw.postMessage("SKIP_WAITING");
      if (reg.waiting) reg.waiting.postMessage("SKIP_WAITING");
      reg.addEventListener("updatefound", () => {
        const nw = reg.installing;
        if (nw) nw.addEventListener("statechange", () => promote(nw));
      });
    }).catch(() => {});
  });
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (refreshing || !hadController) return; // don't reload on first install
    refreshing = true;
    window.location.reload();
  });
}
